import { OnInit, AfterViewInit, SimpleChanges, EventEmitter, OnChanges, ElementRef, Renderer, ChangeDetectorRef } from '@angular/core';
import { DatePipe, isPlatformServer } from '@angular/common';
import { Product } from '../../models/product.model';
import { Unit } from '../../models/unit.model';
import { CheckAvailability } from '../../models/check-availability.model';
import { ProductPriceService } from '../../services/product-price.service';
import { CurrencyService } from '../../shared/currency.service';
import { LoadingComponent } from '../../shared/components/loading/loading.component';
import { AnalyticsUtilsService } from '../../shared/analytics-utils.service';
import { fromEvent } from 'rxjs';
import { DeviceService } from '../../shared/device.service';
import { Subject } from 'rxjs';
import { ScrollService } from '../../shared/scroll-service';
import { take, debounceTime } from 'rxjs/operators';
///  <reference path="../../../../node_modules/@types/jquery/index.d.ts"/>
var ProductPriceComponent = /** @class */ (function () {
    function ProductPriceComponent(productPriceService, currencyService, element, scrollService, renderer, platformId, analytics, device, cdr) {
        this.productPriceService = productPriceService;
        this.currencyService = currencyService;
        this.element = element;
        this.scrollService = scrollService;
        this.renderer = renderer;
        this.analytics = analytics;
        this.device = device;
        this.cdr = cdr;
        this.onGetTotalHeight = new EventEmitter();
        this.onBookClicked = new EventEmitter();
        this.personTypes = [];
        this.isNode = true;
        this.unitsStr = null;
        this.prevDate = null;
        this.availableDays = [];
        this.listOfDays = [];
        this.datepicker = false;
        this.showDatepicker = true;
        this.cancelLoading = false;
        this.isHopOffHopOn = false;
        this.__isPaxOpened = false;
        this.__isDateOpened = false;
        this._buttonDisabled = true;
        this.datePipe = new DatePipe("en-US");
        /**
        * Fires when there is a new Availability
        */
        this.$newAvailability = new Subject();
        this.isNode = isPlatformServer(platformId);
    }
    Object.defineProperty(ProductPriceComponent.prototype, "isPaxSelectorOpened", {
        get: function () {
            return this.__isPaxOpened;
        },
        set: function (nextStatus) {
            if (nextStatus) {
                document.getElementById("availability-legend").style.minHeight = "calc(" + this.element.nativeElement.offsetHeight + "px + 16px)";
                document.getElementById("checkAvailabilityForm").classList.add('opened');
            }
            else {
                if (!this.isDateOpened && !nextStatus) {
                    document.getElementById("availability-legend").removeAttribute('style');
                    document.getElementById("checkAvailabilityForm").classList.remove('opened');
                }
            }
            this.__isPaxOpened = nextStatus;
        },
        enumerable: true,
        configurable: true
    });
    ProductPriceComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (this.options != null && this.options.length > 0) {
            this.product.bestPrice = this.options[0]['total'];
        }
        this.check = new CheckAvailability();
        if (!this.isNode) {
            //Dont open datepicker until first availability arrives.
            if (changes["product"].isFirstChange) {
                this.$newAvailability.asObservable().pipe(take(1)).subscribe(function () {
                    setTimeout(function () {
                        if (changes["product"] && _this.product != null && !_this.isDateOpened) {
                            _this._buttonDisabled = true;
                            // If datepicker exists, it will show only datepicker.
                            if (_this.product != null && !_this.isDateOpened) {
                                _this.datepicker = true;
                                _this.toggleDatepicker();
                            }
                            setTimeout(function () {
                                _this.showDatepicker = false;
                            }, ProductPriceComponent.DELAY_BEFORE_DISPLAY_PAX);
                        }
                    }, 1000);
                });
            }
            if (this.product != null && this.product.hopOnHopOff)
                this.isHopOffHopOn = true;
            if (this.product != null && this.product.isAvailable) {
                this.getAvailabilityProduct(this.product.id);
                this.calculeHighPriceABTest(this.product);
            }
        }
    };
    ProductPriceComponent.prototype.calculeHighPriceABTest = function (product) {
        if (product.bestPriceInfo && product.bestPriceInfo.promotion && product.bestPriceInfo.promotion.promotionType === "RETAIL") {
            var price = product.bestPriceInfo.bestPrice;
            var rate = product.bestPriceInfo.promotion.value;
            this.highPrice = (price * 100) / (100 - rate);
        }
    };
    ProductPriceComponent.prototype.ngOnDestroy = function () {
        this._scrollListener != null ? this._scrollListener.unsubscribe() : null;
    };
    ProductPriceComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (!this.isNode) {
            setTimeout(function () {
                _this.getHeightComponent();
            }, 2000);
        }
    };
    ProductPriceComponent.prototype.ngOnInit = function () {
        this.check = new CheckAvailability();
        if (!this.isNode && (this.device.device !== "desktop")) {
            this._scrollListener = fromEvent(window, 'scroll').pipe(debounceTime(200)).subscribe(function () {
                var divHeight = document.getElementById('availability-legend').offsetHeight;
                var banner = document.getElementById('product-banner').offsetHeight;
                var optionsContainer = document.getElementById('option-container');
                var breakPoint = banner + divHeight;
                if (optionsContainer != null) {
                    var optionsContainerSize = document.getElementById('option-container').offsetHeight;
                    breakPoint += optionsContainerSize;
                }
                var _t1 = document.getElementById("availability-legend").offsetTop;
                var _t2 = window.innerHeight;
                var _t3 = document.getElementById("price-box").offsetTop;
                if (window.innerWidth < 840) {
                    if (window.scrollY > (_t2 - _t3)) {
                        // document.getElementById("button-top-zero").style.opacity = "0";
                        // document.getElementById("button-top-zero").style.pointerEvents = "none";
                        document.getElementById("checkAvailabilityButton").style.opacity = "1";
                        // document.getElementById("red-bar").classList.remove("no-after-or-before");
                    }
                    else {
                        // document.getElementById("button-top-zero").style.opacity = "1";
                        // document.getElementById("button-top-zero").style.pointerEvents = "all";
                        document.getElementById("checkAvailabilityButton").style.opacity = "0";
                        // document.getElementById("red-bar").classList.add("no-after-or-before")
                    }
                }
            });
        }
        this.cdr.detectChanges();
    };
    ProductPriceComponent.prototype.getHeightComponent = function () {
        var _this = this;
        setTimeout(function () {
            var containerRef = _this.element.nativeElement.querySelector('#checkAvailabilityForm').offsetHeight;
            _this.onGetTotalHeight.emit(containerRef);
        }, 100);
    };
    /**
    * Display de pax options to select. (number of adults, child...)
    * @param id product ID
    * @param forceOpen true to force open. false to toggle open/close.
    */
    ProductPriceComponent.prototype.togglePaxDialog = function (id, forceOpen) {
        var _this = this;
        if (forceOpen === void 0) { forceOpen = false; }
        if (this.product.isAvailable == true) {
            if (!forceOpen) {
                this.isPaxSelectorOpened = !this.isPaxSelectorOpened;
            }
            else {
                this.isPaxSelectorOpened = true;
            }
            if ((this.check.date != this.prevDate) || !this.check.units) {
                this.loadingComponentUnits.setHidden(false);
                this.prevDate = this.check.date;
                this.productPriceService.getPersonTypes(id, this.datePipe.transform(this.check.date || new Date(), 'yyyy-MM-dd')).subscribe(function (types) {
                    _this.loadingComponentUnits.setHidden(true);
                    var personTypes = [];
                    types.forEach(function (type) {
                        personTypes.push(new Unit(type));
                    });
                    if (_this.check.units != null) {
                        personTypes = personTypes.map(function (element) {
                            return _this.check.units.find(function (x) {
                                return x.name == element.name;
                            }) || element;
                        });
                    }
                    _this.check.units = personTypes;
                    _this.getHeightComponent();
                });
            }
        }
    };
    /**
    *
    * @param id product id
    * @param date first date to request.
    */
    ProductPriceComponent.prototype.getAvailabilityProduct = function (id, date) {
        var _this = this;
        this.cdr.detectChanges();
        this.listOfDays = [];
        this.cancelLoading = false;
        this.cdr.detectChanges();
        this.productPriceService.getAvailabilityProduct(id, date)
            .subscribe(function (el) {
            if (!date) {
                var days = el.firstAvailableDate.split("-");
                _this.firstDayAvailable = new Date(parseInt(days[0]), parseInt(days[1]) - 1, parseInt(days[2]));
                _this.check.date = _this.firstDayAvailable;
            }
            if (el.dailyAvailability) {
                for (var _i = 0, _a = Object.keys(el.dailyAvailability); _i < _a.length; _i++) {
                    var val = _a[_i];
                    _this.listOfDays.push(val);
                    if (el.dailyAvailability[val] == "ALMOST_SOLD_OUT" || el.dailyAvailability[val] == "AVAILABLE") {
                        _this.availableDays.push(val);
                    }
                }
            }
            _this.listOfDays.sort();
            _this.changeMonth = _this.listOfDays[_this.listOfDays.length - 1];
            _this.cancelLoading = true;
            _this.cdr.detectChanges();
            _this.$newAvailability.next(1);
        });
    };
    ProductPriceComponent.prototype.bookNowClick = function (check) {
        if (this.isReadyToSearch()) {
            this.analytics.send_virtual_page("/seeOptions/", "See Options");
            this.isPaxSelectorOpened = false;
            this.onBookClicked.emit(check);
            var filtered = check.units.filter(function (unit) {
                return unit.pax > 0;
            });
            this.unitsStr = filtered.map(function (unit) {
                return { pax: unit["pax"], name: unit['personType']['name'] };
            });
        }
        else {
            this.togglePaxDialog(this.product.id, true);
        }
        this.getHeightComponent();
    };
    ProductPriceComponent.prototype.removeUnit = function (type) {
        this.analytics.change_pax();
        if (type.pax > 0) {
            type.pax--;
        }
        //Check if all units is 0
        if (type.pax == 0 && this.check.units.find(function (x) { return x.pax > 0; }) == undefined) {
            this._buttonDisabled = true;
        }
    };
    ProductPriceComponent.prototype.addUnit = function (type) {
        this.analytics.change_pax();
        type.pax++;
        this._buttonDisabled = false;
    };
    ProductPriceComponent.prototype.isReadyToSearch = function () {
        var isReady = true;
        if (this.check == null) {
            return false;
        }
        else {
            if (this.product != null && this.product.bookingDateRequired) {
                isReady = this.check.date != null;
            }
            this.isDateOpened = false;
            var units = this.check.units;
            if (units != null) {
                var unit = units.find(function (unit) {
                    return unit.pax > 0;
                });
                isReady = isReady && unit != null;
            }
            else {
                return false;
            }
        }
        return isReady;
    };
    Object.defineProperty(ProductPriceComponent.prototype, "isDateOpened", {
        /**
        * TEMPORAL
        */
        get: function () {
            return this.__isDateOpened;
        },
        set: function (value) {
            var aval = document.getElementById("availability-legend");
            var avalform = document.getElementById("checkAvailabilityForm");
            if (value) {
                if (aval != null && avalform != null) {
                    aval.style.minHeight = "calc(" + this.element.nativeElement.offsetHeight + "px + 16px)";
                    avalform.classList.add('opened');
                    this.__isDateOpened = value;
                }
            }
            else {
                try {
                    this.__isDateOpened = value;
                    this.element.nativeElement.querySelector("#datepicker").remove();
                }
                catch (e) { }
                finally {
                    if (!this.__isDateOpened && !this.isPaxSelectorOpened) {
                        document.getElementById("availability-legend").removeAttribute('style');
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    ProductPriceComponent.prototype.toggleDatepicker = function () {
        if (this.product != null && this.product.isAvailable == true) {
            this.isDateOpened = !this.__isDateOpened;
            this.getHeightComponent();
        }
    };
    ProductPriceComponent.prototype.openDatePicker = function () {
        this.datepicker = true;
        this.isDateOpened = false;
        this.getHeightComponent();
    };
    ProductPriceComponent.prototype.changeDate = function (e) {
        this.prevDate = this.check.date;
        this.dateSelected = e;
        this.isDateOpened = false;
        this.check.date = e;
        this.togglePaxDialog(this.product.id, true);
        this.analytics.change_date();
        this.getHeightComponent();
    };
    ProductPriceComponent.prototype.getDays = function (e) {
        var date = e['date'];
        var nextDay = new Date(date);
        nextDay.setDate(nextDay.getDate() + 1);
        var formatDay = this.datePipe.transform(nextDay, 'yyyy-MM-dd');
        this.getAvailabilityProduct(this.product.id, formatDay);
    };
    ProductPriceComponent.prototype.clickOnPrice = function () {
        this.analytics.click_on_price();
    };
    ProductPriceComponent.DELAY_BEFORE_DISPLAY_PAX = 1000;
    return ProductPriceComponent;
}());
export { ProductPriceComponent };
